import axios from 'axios';

let refreshPromise = null;

/**
 * Single in-flight call to /api/token/refresh, shared by every caller.
 *
 * The backend hands out single-use refresh tokens (gesdinet `single_use: true`),
 * so the cookie is invalidated the moment one refresh consumes it. Two refreshes
 * that overlap therefore send the same cookie twice and the loser gets a 401,
 * even though the session is perfectly healthy. Keep one promise for all of them.
 *
 * Resolves to `{ token, expiresAt }`; the caller stores it through
 * `session/setAccessToken`.
 */
export function requestTokenRefresh() {
    if (!refreshPromise) {
        refreshPromise = axios
            .post(`${import.meta.env.VITE_API_ROOT}/api/token/refresh`, null, {
                withCredentials: true,
            })
            .then((refreshResponse) => {
                const token = refreshResponse.data?.token;
                const expiresAt = refreshResponse.data?.refreshTokenExpiresAt
                    ?? refreshResponse.data?.expiresAt
                    ?? refreshResponse.data?.expires_at
                    ?? null;

                if (!token) {
                    throw new Error('Missing access token from refresh response');
                }

                return { token, expiresAt };
            })
            .finally(() => {
                refreshPromise = null;
            });
    }

    return refreshPromise;
}
